import { useIsMobile } from 'src/reactives/responsive.reactive';
import { useGetSidebarCollapsed } from 'src/reactives/sidebar.reactive';

export const useSidebarCollapsed = () => {
  const { collapsed } = useGetSidebarCollapsed();
  const isMobile = useIsMobile();
  return isMobile ? false : collapsed;
};
